import {styled} from '@linaria/react';

export const SkeletonBlock = styled.div<{
  $width?: `${number}${'%' | 'px'}`;
  $height?: `${number}${'px' | 'vh' | 'vw' | '%' | 'rem'}`;
  disableRoundedCorners?: boolean;
  disableSpaceBelow?: boolean;
}>`
  background-image: linear-gradient(to right, #e4e4e5, #f5f5f5 47%, #e4e4e5);
  position: relative;
  height: ${({$height}) => $height || '18px'};
  width: ${({$width}) => $width || '100%'};
  max-width: 100%;

  border-radius: ${({disableRoundedCorners}) =>
    !disableRoundedCorners ? '4px' : 'unset'};

  margin-bottom: ${({disableSpaceBelow}) => (!disableSpaceBelow ? '1rem' : 0)};

  [data-theme='dark'] & {
    background-image: linear-gradient(to right, #202020, #2a2929 47%, #282727);
  }
`;
